import React, {Component} from 'react';
import firebase from 'firebase/compat/app';
import Preloader from '../../components/Preloader';


export default class Logout extends Component {
	componentDidMount () {
		firebase.auth().signOut()
			.then(() => {
                // this.props.navigate('/');
				// window.location.reload();
				window.open('https://dacomprando.com.ec', '_self');
			})
			.catch(error => {
                console.error(error);
                this.props.navigate('/');
			})
	}

	render () {
		return (<Preloader/>);
	}
}
